import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type {
  PublicationListOut,
  PublicationProgressionDetailOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { PROGRESSION_DEFAULT_TAB, PROGRESSION_SHOW_TABS } from '../constants';
import { ProgressionShowHeader } from './ProgressionShowHeader';
import { ProgressionGeneralTab } from './ProgressionGeneralTab';

export const ProgressionShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<PublicationProgressionDetailOut>({
    resource: 'progress.progressions',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  useRecordDocumentTitle(
    'progress.progressions',
    record && (publication?.title ?? `#${record.id}`)
  );

  const [activeTab, onTabChange] = useShowTab(
    PROGRESSION_SHOW_TABS,
    PROGRESSION_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <ProgressionShowHeader
            record={record}
            publication={publication}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <ProgressionGeneralTab
                record={record}
                publication={publication}
              />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
